import { IPatternWithNoPatternBusinessLogic } from '@vfde-brix/ws10/core';
import {
    createPromoPrice,
    IPromoPriceProperties,
    PromoPrice,
} from '@vfde-brix/ws10/promo-price';

/**
 * Mount promo price
 */
export default function mountPromoPrice (
    id: string,
    properties: IPromoPriceProperties | IPatternWithNoPatternBusinessLogic,
    dom = document,
): PromoPrice | null {
    const container = dom.getElementById(id);

    return container && createPromoPrice(container, properties);
}
